import { injectIntl } from "react-intl";
import { v4 as uuid } from "uuid";
import {
  formatNumberInText,
  firstToUpperCase,
  readLocalStorage,
} from "../../utils";
import {
  browserShape,
  withBrowser,
  withConfiguration,
  withSession,
} from "../../context";
import { intlShape, sessionShape } from "../../shapes";

type Props = {
  browser: browserShape;
  configuration: {
    appName?: string;
    applications?: $TSFixMe;
  };
  intl: intlShape;
  session: sessionShape;
  planVariant: {
    id?: string;
    currency?: string;
    name?: string;
    price?: string;
    type?: string;
    sort?: number;
    popular?: boolean;
    button?: string;
    assets?: number;
    storage?: number;
    short_description?: string;
    features?: string[];
    addons?: $TSFixMe[];
  };
};

export function PlanVariantEnterprise({
  browser,
  configuration,
  intl,
  session,
  planVariant,
}: Props) {
  const handleMouseDown = () => {
    let successUrl;
    if (configuration.appName === "netilion") {
      successUrl = `${readLocalStorage("rootBackUrl")}/subscription/enterprise-quotation-request/success`;
    } else {
      successUrl = session.activeSubscription
        ? // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
          configuration.applications[configuration.appName]
        : // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
          `${configuration.applications[configuration.appName]}/subscription/enterprise-quotation-request/success`;
    }
    browser.redirectToExtern(
      `/enterprise-quotation-request/form?App=${firstToUpperCase(configuration.appName)}&clientAppUrl=${successUrl}`,
    );
  };

  const features = planVariant.features
    ? planVariant.features.map((feature) => (
        <li className="list-item-checked" key={uuid()}>
          {formatNumberInText(feature)}
        </li>
      ))
    : null;

  const shortDescription = planVariant.short_description ? (
    <div id="short-description" className="space-after short-description">
      {planVariant.short_description}
    </div>
  ) : null;

  return (
    <div id="plan-variant-enterprise" className="panel panel-defaul">
      <div className="panel-heading">
        <div className="title">
          {planVariant.name}
          <div className="panel-subtitle">
            {intl.formatMessage({ id: "plan_variant.enterprise.sub_title" })}
          </div>
        </div>
      </div>
      <div className="panel-body">
        {shortDescription}
        <ul className="list-checked">{features}</ul>
      </div>
      <div className="panel-footer">
        <button
          type="button"
          className="btn select-button"
          onMouseDown={handleMouseDown}
        >
          {planVariant.button}
        </button>
      </div>
    </div>
  );
}
export default injectIntl(
  withBrowser(withConfiguration(withSession(PlanVariantEnterprise))),
);
